
const LogoListing = ({ title, description, logos }) => {
  
  return (
    <section className="lg:tw-px-25 tw-p-8">
      <div className="tw-container">
        {title && (
          <h2 className="tw-font-helv tw-text-3.5xl tw-normal-case tw-font-bold tw-mb-4">{title}</h2>
        )}
        {description && (
          <div
            className="tw-prose [&>*]:tw-font-helv"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        <div className="tw-grid tw-grid-cols-2 tw-gap-4 md:tw-grid-cols-3 lg:tw-grid-cols-5">
          {logos?.map(({fields}, index) => (
            <div key={index} className="tw-shadow-md tw-border tw-border-black/20">
              {fields?.icon &&
                <img
                  src={fields.icon.url}
                  alt={fields.icon.label}
                  className="tw-w-full tw-h-auto"
                />
              }
              <div className="tw-pt-2 tw-p-3">
                {fields?.title &&
                  <h3 className="tw-font-helv tw-text-sm tw-normal-case tw-font-bold">{fields.title}</h3>
                }
                {fields?.description &&
                  <div
                    className="tw-prose [&>*]:tw-font-helv tw-mt-4"
                    dangerouslySetInnerHTML={{ __html: fields.description }}
                  />
                }
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoListing;



